(function (window, document) {
  'use strict';

  var SECTION_SELECTOR = '[id^="shopify-section-"]';
  var ACTIONABLE_SELECTOR = 'a[href], a[data-mobile-product-link], button, [role="button"], .btn, [data-click-link]';
  var SLIDER_SELECTOR = 'slideshow-component, images-text, product-showcase';
  var BANNER_SLIDE_SELECTOR = '.swiper-slide';
  var SECTION_THRESHOLD = 0.4;
  var MIN_EXPOSURE_PIXELS = 200;
  var SWIPE_DISTANCE = 40;
  var SWIPE_AXIS_RATIO = 1.5;
  var main = null;
  var sectionObserver = null;
  var bannerObserver = null;
  var pointerStart = null;
  var viewedBannerKeys = {};
  var pageViewTracked = false;

  var MODULE_EVENTS = {
    room_showcase: 'lr_rs_b',
    product_showcase: 'lr_ps_b',
    living_product_grid: 'lr_pg_b',
    multicolumn_icon: 'lr_mc_b',
    images_text: 'lr_it_b',
  };

  function isLivingRoomPage() {
    var page = window.ColamyPage || {};
    var bodyClass = document.body && document.body.className;

    return page.suffix === 'living-room'
      || (typeof bodyClass === 'string' && bodyClass.split(/\s+/).indexOf('living-room') !== -1);
  }

  function analytics() {
    return window.ColamyAnalytics && typeof window.ColamyAnalytics.track === 'function'
      ? window.ColamyAnalytics
      : null;
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function sectionFromElement(element) {
    if (!element || typeof element.closest !== 'function') return null;
    return element.closest(SECTION_SELECTOR);
  }

  function sectionHandle(section) {
    var id = section && section.id ? section.id.replace(/^shopify-section-/, '') : '';
    var instance = id.indexOf('__') === -1 ? id : id.split('__').pop();

    if (
      /^[a-f0-9]{16,}$/i.test(instance)
      && section
      && section.querySelector
      && section.querySelector('.section-app')
    ) {
      return 'apps';
    }
    return instance.replace(/_[A-Za-z0-9]+$/, '');
  }

  function sectionPosition(section) {
    if (!main || !section || typeof main.querySelectorAll !== 'function') return null;
    var sections = Array.prototype.slice.call(main.querySelectorAll(SECTION_SELECTOR));
    var index = sections.indexOf(section);

    return index < 0 ? null : index + 1;
  }

  function sectionProperties(element) {
    var section = sectionFromElement(element);
    var handle = sectionHandle(section);
    var declaredType = section && section.getAttribute && section.getAttribute('data-section-type');

    return {
      section_id: section ? section.id : '',
      section_type: declaredType || handle.replace(/_/g, '-'),
      section_handle: handle,
      position: sectionPosition(section),
    };
  }

  function track(eventName, action, element, properties) {
    var client = analytics();
    if (!client) return null;

    return client.track(eventName, Object.assign(
      { event_action: action, event_detail: eventName },
      element ? sectionProperties(element) : {},
      properties || {}
    ));
  }

  function viewportHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || 0;
  }

  function isExposureVisible(element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return true;
    var rect = element.getBoundingClientRect();
    var viewport = viewportHeight();
    if (!viewport || rect.bottom <= 0 || rect.top >= viewport) return false;
    var visiblePixels = Math.min(rect.bottom, viewport) - Math.max(rect.top, 0);
    var requiredPixels = Math.min(MIN_EXPOSURE_PIXELS, viewport / 2);

    return (requiredPixels > 0 && visiblePixels >= requiredPixels)
      || visiblePixels / Math.max(rect.height || 1, 1) >= SECTION_THRESHOLD;
  }

  function elementPosition(element, selector) {
    var section = sectionFromElement(element);
    if (!section || typeof section.querySelectorAll !== 'function') return null;
    var elements = Array.prototype.slice.call(section.querySelectorAll(selector));
    var index = elements.indexOf(element);

    return index < 0 ? null : index + 1;
  }

  function blockId(element) {
    var block = element && element.closest && element.closest('[data-block-id]');
    if (block && block.dataset) return block.dataset.blockId || '';

    var editorBlock = element && element.closest && element.closest('[data-shopify-editor-block]');
    if (!editorBlock || !editorBlock.getAttribute) return '';
    try {
      return JSON.parse(editorBlock.getAttribute('data-shopify-editor-block') || '{}').id || '';
    } catch (error) {
      return '';
    }
  }

  function clickProperties(element) {
    var text = cleanText(element && element.textContent);
    return {
      block_id: blockId(element),
      click_name: text,
      button_text: text,
      button_type: element && element.tagName ? element.tagName.toLowerCase() : '',
      href: element && (
        element.href
        || element.dataset && (element.dataset.mobileProductLink || element.dataset.clickLink)
        || element.getAttribute && element.getAttribute('href')
      ) || '',
      position: elementPosition(element, ACTIONABLE_SELECTOR),
    };
  }

  function bannerIndex(slide) {
    if (!slide) return null;
    var datasetIndex = slide.dataset && slide.dataset.index;
    if (datasetIndex !== undefined && datasetIndex !== null && datasetIndex !== '') {
      var parsedIndex = parseInt(datasetIndex, 10);
      return isNaN(parsedIndex) ? null : parsedIndex + 1;
    }
    return elementPosition(slide, BANNER_SLIDE_SELECTOR);
  }

  function bannerProperties(slide) {
    var title = slide && slide.querySelector && slide.querySelector('.slideshow__title');
    return {
      banner_id: slide && slide.dataset ? slide.dataset.blockId || blockId(slide) : '',
      banner_index: bannerIndex(slide),
      banner_type: slide && slide.dataset ? slide.dataset.type || '' : '',
      banner_name: cleanText(title && title.textContent),
      banner_text: cleanText(slide && slide.textContent),
    };
  }

  function isBannerSlider(slider) {
    return slider && sectionHandle(sectionFromElement(slider)) === 'slideshow_banner';
  }

  function activeBannerSlide(slider) {
    if (!isBannerSlider(slider) || typeof slider.querySelector !== 'function') return null;
    return slider.querySelector('.swiper-slide-active')
      || slider.querySelector('[aria-hidden="false"]')
      || slider.querySelector(BANNER_SLIDE_SELECTOR);
  }

  function trackBannerView(slide) {
    if (!slide || !slide.dataset) return;
    var properties = bannerProperties(slide);
    var key = sectionProperties(slide).section_id + ':' + (properties.banner_id || properties.banner_index);
    if (viewedBannerKeys[key]) return;

    if (track('lr_sb_v', 'view', slide, properties) !== null) viewedBannerKeys[key] = true;
  }

  function trackActiveBannerView(slider) {
    if (!isExposureVisible(slider)) return;
    trackBannerView(activeBannerSlide(slider));
  }

  function isDisabled(element) {
    return Boolean(element && (
      element.disabled
      || element.getAttribute && element.getAttribute('aria-disabled') === 'true'
      || element.getAttribute && element.getAttribute('disabled') !== null
    ));
  }

  function controlType(control) {
    var className = control && control.className ? String(control.className) : '';
    if (className.indexOf('swiper-button-next') !== -1) return 'next';
    if (className.indexOf('swiper-button-prev') !== -1) return 'previous';
    return 'pagination';
  }

  function sliderForControl(control) {
    if (!control || typeof control.closest !== 'function') return null;
    var section = sectionFromElement(control);
    return control.closest(SLIDER_SELECTOR)
      || (section && section.querySelector && section.querySelector(SLIDER_SELECTOR));
  }

  function productContext(element) {
    var slide = element && element.closest && element.closest('.product-showcase__slide');
    var card = element && element.closest && element.closest('.product-column');
    var title = slide && slide.querySelector
      ? slide.querySelector('.product-showcase__title')
      : card && card.querySelector && card.querySelector('.product-card__title, .card-product__title, .reversed-link');

    return {
      product_name: cleanText(title && title.textContent),
      product_position: slide
        ? bannerIndex(slide)
        : card ? elementPosition(card, '.product-column') : null,
    };
  }

  function handleClick(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;

    var summary = target.closest('.accordion-details__summary');
    if (summary) {
      var details = summary.closest('details');
      var section = sectionFromElement(summary);
      var summaries = section && section.querySelectorAll
        ? Array.prototype.slice.call(section.querySelectorAll('.accordion-details__summary'))
        : [];
      track('lr_ct_ch', details && details.open ? 'collapse' : 'expand', summary, {
        question_text: cleanText(summary.textContent),
        question_position: summaries.indexOf(summary) + 1,
      });
      return;
    }

    var control = target.closest('.swiper-button, .swiper-pagination-bullet');
    if (control) {
      var slider = sliderForControl(control);
      if (slider) {
        track('lr_sl_c', 'click', control, {
          slider_type: slider.tagName ? slider.tagName.toLowerCase() : '',
          control_type: controlType(control),
        });
        return;
      }
    }

    var actionable = target.closest(ACTIONABLE_SELECTOR);
    if (!actionable || isDisabled(actionable)) return;
    var slide = actionable.closest(BANNER_SLIDE_SELECTOR);
    var handle = sectionHandle(sectionFromElement(actionable));

    if (slide && handle === 'slideshow_banner') {
      track('lr_sb_b', 'click', actionable, Object.assign(
        bannerProperties(slide),
        clickProperties(actionable)
      ));
      return;
    }

    if (handle === 'apps' || actionable.closest('.section-app')) {
      track('lr_app_b', 'click', actionable, clickProperties(actionable));
      return;
    }

    var properties = clickProperties(actionable);
    if (handle === 'product_showcase' || handle === 'living_product_grid') {
      properties = Object.assign(properties, productContext(actionable));
    }
    track(MODULE_EVENTS[handle] || 'lr_b', 'click', actionable, properties);
  }

  function findSlider(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(SLIDER_SELECTOR);
  }

  function sliderIndex(slider) {
    if (!slider) return null;
    var attribute = slider.getAttribute && slider.getAttribute('selected-index');
    if (attribute !== null && attribute !== '') return String(attribute);
    var instance = slider.sliderInstance && slider.sliderInstance.slider;
    var index = instance && (instance.realIndex !== undefined ? instance.realIndex : instance.activeIndex);
    return typeof index === 'number' ? String(index) : null;
  }

  function handlePointerDown(event) {
    if (event && event.pointerType === 'mouse' && event.button !== 0) return;
    var slider = findSlider(event && event.target);
    if (!slider) return;
    pointerStart = {
      target: slider,
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      selectedIndex: sliderIndex(slider),
    };
  }

  function handlePointerUp(event) {
    if (!pointerStart) return;
    var start = pointerStart;
    pointerStart = null;
    if (
      start.pointerId !== undefined
      && event.pointerId !== undefined
      && start.pointerId !== event.pointerId
    ) return;

    var deltaX = event.clientX - start.x;
    var deltaY = event.clientY - start.y;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);
    if (absX < SWIPE_DISTANCE || absX < absY * SWIPE_AXIS_RATIO) return;
    var selectedIndex = sliderIndex(start.target);
    if (selectedIndex === null || selectedIndex === start.selectedIndex) return;

    track('lr_sl_sw', 'swipe', start.target, {
      slider_type: start.target.tagName ? start.target.tagName.toLowerCase() : '',
      direction: deltaX < 0 ? 'next' : 'previous',
      selected_index: selectedIndex,
    });
  }

  function trackSectionView(section) {
    if (!section || !section.dataset || section.dataset.colamyLivingRoomViewed === 'true') return;
    if (track('lr_s_v', 'view', section) === null) return;
    section.dataset.colamyLivingRoomViewed = 'true';
    var slider = section.querySelector && section.querySelector(SLIDER_SELECTOR);
    if (slider) trackActiveBannerView(slider);
    if (sectionObserver && typeof sectionObserver.unobserve === 'function') {
      sectionObserver.unobserve(section);
    }
  }

  function observeSections() {
    var sections = main && main.querySelectorAll ? main.querySelectorAll(SECTION_SELECTOR) : [];
    var Observer = window.IntersectionObserver;
    if (typeof Observer !== 'function') {
      Array.prototype.forEach.call(sections, trackSectionView);
      return;
    }

    if (!sectionObserver) {
      sectionObserver = new Observer(function (entries) {
        entries.forEach(function (entry) {
          var visiblePixels = entry.intersectionRect && entry.intersectionRect.height || 0;
          if (entry.isIntersecting && (
            entry.intersectionRatio >= SECTION_THRESHOLD
            || (viewportHeight() > 0 && visiblePixels >= Math.min(MIN_EXPOSURE_PIXELS, viewportHeight() / 2))
          )) trackSectionView(entry.target);
        });
      }, { threshold: [0, SECTION_THRESHOLD] });
    }

    Array.prototype.forEach.call(sections, function (section) {
      if (!section.dataset || section.dataset.colamyLivingRoomObserved === 'true') return;
      section.dataset.colamyLivingRoomObserved = 'true';
      sectionObserver.observe(section);
    });
  }

  function observeSliders() {
    var sliders = main && main.querySelectorAll ? main.querySelectorAll(SLIDER_SELECTOR) : [];
    var MutationObserverConstructor = window.MutationObserver || window.WebKitMutationObserver;

    Array.prototype.forEach.call(sliders, function (slider) {
      if (!slider || !slider.dataset || slider.dataset.colamyLivingRoomSliderObserved === 'true') return;
      slider.dataset.colamyLivingRoomSliderObserved = 'true';
      trackActiveBannerView(slider);

      if (isBannerSlider(slider) && typeof window.IntersectionObserver === 'function') {
        if (!bannerObserver) {
          bannerObserver = new window.IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) trackActiveBannerView(entry.target);
            });
          }, { threshold: [0, SECTION_THRESHOLD] });
        }
        bannerObserver.observe(slider);
      }

      if (typeof MutationObserverConstructor !== 'function') return;
      var previousSelectedIndex = slider.getAttribute && slider.getAttribute('selected-index');
      var observer = new MutationObserverConstructor(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'selected-index') return;
          var selectedIndex = slider.getAttribute && slider.getAttribute('selected-index');
          if (selectedIndex === previousSelectedIndex) return;
          if (previousSelectedIndex === null) {
            previousSelectedIndex = selectedIndex;
            trackActiveBannerView(slider);
            return;
          }
          previousSelectedIndex = selectedIndex;
          track('lr_sl_ch', 'change', slider, {
            slider_type: slider.tagName ? slider.tagName.toLowerCase() : '',
            selected_index: selectedIndex || '',
          });
          trackActiveBannerView(slider);
        });
      });
      observer.observe(slider, { attributes: true, attributeFilter: ['selected-index'] });
    });
  }

  function init() {
    if (window.__colamyLivingRoomAnalyticsInitialized || !isLivingRoomPage() || !analytics()) return;
    main = document.querySelector && document.querySelector('#MainContent');
    if (!main || typeof main.addEventListener !== 'function') return;

    window.__colamyLivingRoomAnalyticsInitialized = true;
    main.addEventListener('click', handleClick);
    main.addEventListener('pointerdown', handlePointerDown);
    main.addEventListener('pointerup', handlePointerUp);
    main.addEventListener('pointercancel', function () { pointerStart = null; });

    if (typeof analytics().onConsentChange === 'function') {
      analytics().onConsentChange(function (state) {
        if (state.analytics !== 'granted') return;
        if (!pageViewTracked && track('lr_p_v', 'view') !== null) pageViewTracked = true;
        Array.prototype.forEach.call(main.querySelectorAll(SECTION_SELECTOR), function (section) {
          if (isExposureVisible(section)) trackSectionView(section);
        });
        Array.prototype.forEach.call(main.querySelectorAll(SLIDER_SELECTOR), trackActiveBannerView);
      });
    } else if (track('lr_p_v', 'view') !== null) {
      pageViewTracked = true;
    }

    observeSections();
    observeSliders();
    document.addEventListener('shopify:section:load', function () {
      observeSections();
      observeSliders();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
